import { api } from "./client";
// import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createStock = async (payload) => {
  try {
    const response = await api.post(
      `${API_BASE_URL}api/stock/stock`,
      payload
    );
    return response.data;
  } catch (error) {
    // Throw the error again so the calling function can handle it
    throw error.response?.data || { message: "Something went wrong" };
  }
};

export const updateStock = async (id, data) => {
    try{
  const res = await api.put(`${API_BASE_URL}api/stock/stock/${id}`, data);
  return res.data;
    }
    catch (error) {
      // Handle the error appropriately
      throw error.response?.data || { message: "Failed to update stock" };
    }
};

export const getAllStocks = async () => {
  try {
    const res = await api.get(`${API_BASE_URL}api/stock/stock-list`);
    if (res.data.success) {
      return res.data.data;
    } else {
      throw new Error(res.data.message || "Failed to fetch stock list.");
    }
  } catch (err) {
    throw new Error(
      err.response?.data?.message || err.message || "Server Error"
    );
  }
};

export const deleteStock = async (id) => {
  const response = await api.delete(`${API_BASE_URL}api/stock/${id}`);
  return response.data;
};
